import { Card, styled } from '@mui/material'
import { Percentage, RectangleIcon, Typography } from 'ComponentLibrary'
import { ComputedDatum } from '@nivo/pie'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type DatumType = {
    id: string
    label: string
    color: string
    value: number
}

type DataSplitTooltipPropsType = {
    datum: ComputedDatum<DatumType>
    total: number
}

export function EnergyEfficiencyTooltip({ datum, total }: DataSplitTooltipPropsType) {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()
    const percentage = new Percentage(datum.value / total).format({ locale })
    //get average angle arc and convert to degrees (to determine if the arc is on the upper half of the pie, flip the tooltip)
    const averageAnglePos = (datum.arc.endAngle + datum.arc.startAngle) / 2
    const transformY = averageAnglePos > (Math.PI * 3) / 2 || averageAnglePos < Math.PI / 2 ? '150%' : '0'

    return (
        <StyledTooltip $transformY={transformY}>
            <Typography variant="headline5">
                <ColoredBox $color={datum.color}>
                    <RectangleIcon />
                </ColoredBox>
                {datum.label}
            </Typography>

            <Typography variant="bodyTextSmall">
                {tCommon('count')}:{' '}
                <Typography variant="headline5" style={{ display: 'inline' }}>
                    {datum.formattedValue.replace(' ', '')}
                </Typography>
            </Typography>

            <Typography variant="bodyTextSmall">
                {tCommon('share')}:{' '}
                <Typography variant="headline5" style={{ display: 'inline' }}>
                    {percentage.replace(' ', '')}
                </Typography>
            </Typography>
        </StyledTooltip>
    )
}

const StyledTooltip = styled(Card, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $transformY: string }>(({ $transformY, theme }) => ({
    background: theme.palette.background.paper,
    transform: `translate(0, ${$transformY})`,
    padding: '6px 10px',
    lineHeight: '1.4',
}))

const ColoredBox = styled('div', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})(({ $color }: { $color: string }) => ({
    color: $color,
    marginRight: '4px',
    display: 'inline',
    '& svg': {
        marginBottom: '-1px',
    },
}))
